import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect } from 'react';
import { Button, Input, Icon } from 'semantic-ui-react';
import { DEFAULT_TIP_PERCENTAGE_OPTIONS, DEFAULT_TIP_PERCENTAGE, NO_TIP_COPY, TIP_MAX_VALUE } from './TipSelector.constants';
import { formatTipAmount } from './TipSelector.utils';
import useDebounce from '../../../hooks/use-debounce';
import './TipSelector.css';
var defaultProps = {
  percentageOptions: DEFAULT_TIP_PERCENTAGE_OPTIONS
};
export default function TipSelector(_ref) {
  var percentageOptions = _ref.percentageOptions,
    onChange = _ref.onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCustom = _useState2[0],
    setIsCustom = _useState2[1];
  var _useState3 = useState(DEFAULT_TIP_PERCENTAGE),
    _useState4 = _slicedToArray(_useState3, 2),
    tipValue = _useState4[0],
    setTipValue = _useState4[1];
  var debouncedTipValue = useDebounce(tipValue, 2000);
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  function changeTip(_x) {
    return _changeTip.apply(this, arguments);
  }
  function _changeTip() {
    _changeTip = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var _ref5,
        _ref5$isDebouncing,
        isDebouncing,
        _ref5$force,
        force,
        target,
        value,
        isPercentage,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref5 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref5$isDebouncing = _ref5.isDebouncing, isDebouncing = _ref5$isDebouncing === void 0 ? false : _ref5$isDebouncing, _ref5$force = _ref5.force, force = _ref5$force === void 0 ? false : _ref5$force;
            target = e.target;
            value = target.value;
            if (!(value > TIP_MAX_VALUE || value < 0 || loading)) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return");
          case 5:
            if (!(value === tipValue && !force)) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return");
          case 7:
            _context2.prev = 7;
            if (!isDebouncing) {
              setLoading(true);
            }
            setTipValue(value);
            isPercentage = !isCustom;
            _context2.next = 13;
            return onChange(e, {
              value: isPercentage ? +value : +formatTipAmount(value),
              isPercentage: isPercentage,
              isCustom: isCustom,
              isDebouncing: isDebouncing
            });
          case 13:
            setLoading(false);
            _context2.next = 19;
            break;
          case 16:
            _context2.prev = 16;
            _context2.t0 = _context2["catch"](7);
            setLoading(false);
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[7, 16]]);
    }));
    return _changeTip.apply(this, arguments);
  }
  useEffect(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!isCustom) {
            _context.next = 3;
            break;
          }
          _context.next = 3;
          return changeTip({
            target: {
              value: +debouncedTipValue
            }
          }, {
            force: true
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [debouncedTipValue]);
  function onButtonGroupClick(_x2, _x3) {
    return _onButtonGroupClick.apply(this, arguments);
  }
  function _onButtonGroupClick() {
    _onButtonGroupClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, _ref3) {
      var value;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            value = _ref3.value;
            _context3.next = 3;
            return changeTip(_objectSpread(_objectSpread({}, e), {}, {
              target: _objectSpread(_objectSpread({}, e.target), {}, {
                value: +value
              })
            }));
          case 3:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _onButtonGroupClick.apply(this, arguments);
  }
  function onCustomInputChange(_x4, _x5) {
    return _onCustomInputChange.apply(this, arguments);
  }
  function _onCustomInputChange() {
    _onCustomInputChange = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e, _ref4) {
      var value;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            value = _ref4.value;
            _context4.next = 3;
            return changeTip(_objectSpread(_objectSpread({}, e), {}, {
              target: _objectSpread(_objectSpread({}, e.target), {}, {
                value: +value
              })
            }), {
              isDebouncing: true
            });
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _onCustomInputChange.apply(this, arguments);
  }
  function showCustom(_x6) {
    return _showCustom.apply(this, arguments);
  }
  function _showCustom() {
    _showCustom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setIsCustom(true);
            _context5.next = 3;
            return changeTip(_objectSpread(_objectSpread({}, e), {}, {
              target: _objectSpread(_objectSpread({}, e.target), {}, {
                value: 0
              })
            }), {
              isDebouncing: true
            });
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return _showCustom.apply(this, arguments);
  }
  function hideCustom(_x7) {
    return _hideCustom.apply(this, arguments);
  }
  function _hideCustom() {
    _hideCustom = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            setIsCustom(false);
            _context6.next = 3;
            return changeTip(_objectSpread(_objectSpread({}, e), {}, {
              target: _objectSpread(_objectSpread({}, e.target), {}, {
                value: DEFAULT_TIP_PERCENTAGE
              })
            }));
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _hideCustom.apply(this, arguments);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "checkout-tip-selector-container"
  }, !isCustom && /*#__PURE__*/React.createElement(Button.Group, {
    basic: true,
    compact: true,
    fluid: true
  }, percentageOptions.map(function (percentage) {
    return /*#__PURE__*/React.createElement(Button, {
      key: percentage,
      content: +percentage === 0 ? NO_TIP_COPY : "".concat(percentage, "%"),
      value: percentage,
      onClick: onButtonGroupClick,
      active: +percentage === +tipValue,
      disabled: loading
    });
  }), /*#__PURE__*/React.createElement(Button, {
    content: "Other",
    onClick: showCustom,
    disabled: loading
  })), isCustom && /*#__PURE__*/React.createElement("div", {
    className: "custom-tip-container"
  }, /*#__PURE__*/React.createElement(Input, {
    label: "$",
    labelPosition: "right",
    step: 0.01,
    min: 0,
    max: TIP_MAX_VALUE,
    className: "custom-tip-input",
    onChange: onCustomInputChange,
    type: "number",
    value: formatTipAmount(tipValue),
    disabled: loading
  }), !loading && /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    onClick: hideCustom
  })));
}
TipSelector.defaultProps = defaultProps;